// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__18X99","title":"AfterBackImages_title__2plp2","images":"AfterBackImages_images__1ZegS"};